<template>
  <div>
    <b-form v-if="entity !== null">
      <b-row>
        <template v-for="config in formConfig.configs ">
          <b-col :cols="config.cols" :md="config.md">
            <validation-provider
                #default="validationContext"
                :name="config.name"
                :disabled="config.type === FieldType.SWITCH"
                rules="required"
            >
              <b-form-group v-if="config.type !== FieldType.HIDE" :label="config.label"
                            :label-for="config.name">
                <b-form-input v-if="config.type === FieldType.TEXT"
                              :state="getValidationState(validationContext)"
                              :id="config.name"
                              v-model="entity[config.name]"
                />
                <b-form-input v-if="config.type === FieldType.PASSWORD"
                              :state="getValidationState(validationContext)"
                              :id="config.name"
                              type="password"
                              v-model="entity[config.name]"
                />


                <b-form-input v-if="config.type === FieldType.EMAIL"
                              :id="config.name"
                              v-model="entity[config.name]"
                />
                <b-form-input v-if="config.type === FieldType.NUMBER"
                              :id="config.name"
                              v-model="entity[config.name]"
                />
                <b-form-textarea
                    v-if="config.type === FieldType.TEXTAREA"
                    :id="config.name"
                    v-model="entity[config.name]"
                    rows="3"
                />
                <ckfinder
                    v-if="config.type === FieldType.CK_IMAGE"
                    :id="config.name"
                    v-model="entity[config.name]"

                />
                <b-form-checkbox v-if="config.type === FieldType.SWITCH"

                                 :id="config.name"
                                 v-model="entity[config.name]"
                                 switch
                                 inline
                />

                <v-select v-if="config.type === FieldType.SELECT_ARRAY"
                          v-model="entity[config.name]"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="config.refs.value"
                          :reduce="val => {
                              return val;
                          }"
                          :clearable="false"
                          :input-id="config.name"
                />


                <v-select v-if="config.type === FieldType.MULTIPLE"
                          v-model="entity[config.name]"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="config.refs.value"
                          :reduce="val => {
                              console.log(val);
                              return val.value;
                          }"
                          multiple
                          :clearable="false"
                          :input-id="config.name"
                />

                <v-select v-if="config.type === FieldType.SELECT"
                          v-model="entity[config.name]"
                          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                          :options="config.refs.value"
                          :reduce="val => val.value"
                          :clearable="false"
                          :input-id="config.name"
                />


                <flat-pickr v-if="config.type === FieldType.DATE"
                            v-model="entity[config.name]"
                            class="form-control"
                            :config="{ enableTime: true,dateFormat: 'Y-m-d H:i'}"
                />


                <prism-editor class="my-editor" v-if="config.type === FieldType.FREEMARKER"
                              v-model="entity[config.name]" :highlight="highlighter" line-numbers>
                </prism-editor>


                <b-form-invalid-feedback>
                  {{ validationContext.errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-col>

        </template>

      </b-row>
    </b-form>
    <slot name="button"></slot>

  </div>
</template>

<script>

import {
  BAvatar,
  BButton,
  BCard,
  BCardHeader,
  BCardTitle,
  BCol,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BMedia,
  BRow,
  BTable,
  BFormTextarea,
  BCardBody,
  BFormInvalidFeedback,
} from 'bootstrap-vue'

import {avatarText} from '@core/utils/filter'
import {ref} from '@vue/composition-api'
import vSelect from 'vue-select'
import store from '@/store'
import {FormConfig, FieldType} from '../common/index.d.ts'
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import formValidation from '@core/comp-functions/forms/form-validation'
import userStore from './storeModule'
import Ckfinder from '../../components/ckfinder/Ckfinder'
//import 'prismjs'
//import Prism from 'vue-prism-component'
import {PrismEditor} from 'vue-prism-editor';
import {highlight, languages} from 'prismjs/components/prism-core';

import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';

import 'prismjs/themes/prism-tomorrow.css';
import 'vue-prism-editor/dist/prismeditor.min.css';

import flatPickr from 'vue-flatpickr-component'


export default {

  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    Ckfinder,
    BFormInvalidFeedback,
    ValidationProvider,
    ValidationObserver,
    Prism,
    flatPickr,

    PrismEditor,
    BCardBody,

  },
  props: {
    formConfig: {
      type: FormConfig,
      required: true,
    },
    entity: {
      type: [Object],
      required: true,
    },
  },
  setup(props) {
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation()


    let highlighter = (code) => {
      return highlight(code, languages.js, "js");
    }

    let r = {
      refFormObserver,
      getValidationState,
      resetForm,
      avatarText,
      FieldType,
      //   entity,
      console,
      highlighter,
    };
    let configs = props.formConfig.configs;
    configs.forEach(config => {
      if (config.action) {
        let ref = config.refs;
        r[config.name + "_ref"] = ref;
        store.dispatch(`${config.action}`)
            .then(response => {
              let res = [];
              response.data.data.forEach((f) => {
                res.push({label: f.name, value: f.id})
              })
              ref.value = res
            })
            .catch(error => {
              if (error.response.status === 404) {

              }
            })
      }
    })
    return r;
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/base/bootstrap-extended/variables';
@import 'bootstrap/scss/variables';
@import '~@core/scss/base/components/variables-dark';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>

<style>
.height-200 {
  height: 200px
}

.my-editor {
  /* we dont use `language-` classes anymore so thats why we need to add background and text color manually */
  background: #2d2d2d;
  color: #ccc;

  /* you must provide font-family font-size line-height. Example:*/
  font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  padding: 5px;
}

.my-editor pre {
  color: white;
}

/* optional class for removing the outline */
.prism-editor__textarea:focus {
  outline: none;
}
</style>

